import { initialState, Actions, State, NEW_USER, NEW_USER_SUCCESS, NEW_USER_ERROR } from '../../types/user/new'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case NEW_USER:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case NEW_USER_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case NEW_USER_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      }
    default:
      return state
  }
}

export default reducers
